import { WalletConversionStatusResp } from 'types/api/response/wallet-conversion-status-resp'

import { api } from './api'

export const getWalletConversionStatus = () =>
  api.get<WalletConversionStatusResp>('/business_accounts/conversion')
